"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvatarChildrenProps = void 0;
var helpers_1 = require("../../utils/helpers");
function getAvatarChildrenProps(_a) {
    var children = _a.children, withInitials = _a.withInitials, src = _a.src, alt = _a.alt, height = _a.height, style = _a.style;
    var childrenText = helpers_1.getTextFromReactChildren(children);
    if (!src && withInitials && !!childrenText) {
        var backgroundColor = helpers_1.getColorFormString(childrenText);
        return {
            style: __assign({ backgroundColor: backgroundColor,
                height: height, width: height }, style),
            children: "" + childrenText.split(" ")[0][0] + childrenText.split(" ")[1][0],
        };
    }
    return {
        src: src,
        alt: alt,
        style: __assign({ height: height + 16, width: height + 16 }, style),
    };
}
exports.getAvatarChildrenProps = getAvatarChildrenProps;
//# sourceMappingURL=helpers.js.map